import http from "../../config/http";
import { AUTENTICAR_USUARIO } from "../endpoints";


const postAutenticarUsuario = (cedula,clave) => {
  return http.post(`Usuario/${AUTENTICAR_USUARIO}?cedula=${cedula}&clave=${clave}` );
};

export { postAutenticarUsuario };
